<script>
export default {
  name: 'LegacyNotification',
  props: {
    text: { type: String, default: '' },
    icon: { type: String, default: '' },
    link: { type: String, default: '' },
    initialViewed: { type: Boolean, default: false },
  },
  emits: ['interactedWith'],
  data() {
    return { viewed: this.initialViewed }
  },
  methods: {
    handleClick() {
      this.viewed = true
      this.$emit('interactedWith')
      if (this.link) window.open(this.link, '_blank', 'noopener')
    },
  },
}
</script>

<template>
  <button
    type="button"
    class="w-full text-left flex items-start gap-3 rounded-lg border border-border p-3 mb-2 hover:bg-muted/50 transition-colors"
    :class="viewed ? 'bg-muted/30 opacity-70' : 'bg-card'"
    @click="handleClick"
  >
    <img
      v-if="icon"
      :src="icon"
      alt=""
      class="w-8 h-8 rounded object-contain border border-border bg-white flex-shrink-0"
    />
    <p class="text-sm text-foreground flex-1">{{ text }}</p>
  </button>
</template>
